import i18next from "i18next";

const prodFrontEndPoint = process.env.REACT_APP_PROD_FRONT_URL;
const appEnv = process.env.REACT_APP_ENV;

let apiUrl = "";

if (appEnv === "production" && window?.location?.origin === prodFrontEndPoint) {
  apiUrl = process.env.REACT_APP_PROD_API_URL;
} else if (appEnv === "test") {
  apiUrl = process.env.REACT_APP_TEST_API_URL;
}

/**
 * SSE EventSource 생성
 */
export function createSse({}) {
  const token = localStorage.getItem("signToken");
  const lang = i18next.language;

  const params = new URLSearchParams({
    lang,
    ...(token ? { token } : {}),
  });

  return new EventSource(`${apiUrl}/sse?${params.toString()}`, {
    withCredentials: true,
  });
}
